import React from 'react';

const API_URL = 'https://heybiseo.ai.kr';

const STATUS_META = {
  available: { label: '사용가능', color: '#2563EB', bg: '#EFF6FF', dot: '#2563EB' },
  in_use:    { label: '사용중',   color: '#16A34A', bg: '#F0FDF4', dot: '#16A34A' },
  expiring:  { label: '임박',     color: '#D97706', bg: '#FFFBEB', dot: '#D97706' },
  expired:   { label: '만료',     color: '#EF4444', bg: '#FFF0F0', dot: '#EF4444' },
  disabled:  { label: '사용불가', color: '#8B5CF6', bg: '#F5F3FF', dot: '#8B5CF6' },
};

function LockersPage({ token }) {
  const [zones, setZones] = React.useState([]);
  const [lockers, setLockers] = React.useState([]);
  const [summary, setSummary] = React.useState({});
  const [members, setMembers] = React.useState([]);
  const [selectedZone, setSelectedZone] = React.useState(null);
  const [filterStatus, setFilterStatus] = React.useState('all');
  const [showAssignModal, setShowAssignModal] = React.useState(false);
  const [showZoneModal, setShowZoneModal] = React.useState(false);
  const [zoneTab, setZoneTab] = React.useState('create');
  const [selectedLocker, setSelectedLocker] = React.useState(null);
  const [memberSearch, setMemberSearch] = React.useState('');
  const [lockerQuery, setLockerQuery] = React.useState('');
  const [selectedMember, setSelectedMember] = React.useState(null);
  const [editZoneTarget, setEditZoneTarget] = React.useState(null);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [editForm, setEditForm] = React.useState({ end_date: '', password: '', memo: '', locker_id: '', zone_id: '', locker_number: '' });
  const [memberLockerPlans, setMemberLockerPlans] = React.useState([]);
  const [assignForm, setAssignForm] = React.useState({
    zone_id: '', locker_number: '', password: '', memo: '',
    start_date: new Date().toISOString().slice(0, 10), end_date: '',
  });
  const [zoneForm, setZoneForm] = React.useState({
    name: '', rows: 10, cols: 10, start_num: 1, end_num: 100,
    start_position: '왼쪽상단', direction: '좌우'
  });
  const [editZoneForm, setEditZoneForm] = React.useState({
    name: '', rows: 10, cols: 10, start_num: 1, end_num: 100,
    start_position: '왼쪽상단', direction: '좌우'
  });

  const headers = { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };

  React.useEffect(() => { loadAll(); }, []);

  async function handleUpdate() {
    if (!editForm.end_date) { alert('만료일을 입력해주세요.'); return; }
    try {
      let locker_id = null;
      if (editForm.zone_id && editForm.locker_number) {
        const locker = lockers.find(l => l.zone_id === Number(editForm.zone_id) && l.number === Number(editForm.locker_number));
        if (!locker) { alert('해당 락커를 찾을 수 없습니다.'); return; }
        if (locker.id !== selectedLocker.locker_id) locker_id = locker.id;
      }
      const res = await fetch(`${API_URL}/locker/assign/${selectedLocker.assignment_id}`, {
        method: 'PUT', headers,
        body: JSON.stringify({
          end_date: editForm.end_date,
          password: editForm.password,
          memo: editForm.memo,
          ...(locker_id ? { locker_id } : {})
        })
      });
      if (!res.ok) { const e = await res.json(); alert(e.detail || '수정 실패'); return; }
      setShowEditModal(false);
      setSelectedLocker(null);
      await loadAll();
    } catch (e) { alert('수정 중 오류가 발생했습니다.'); }
  }

  async function loadAll() {
    try {
      const [z, l, s, m] = await Promise.all([
        fetch(`${API_URL}/locker/zones?tenant_id=1`, { headers }).then(r => r.json()),
        fetch(`${API_URL}/locker/list?tenant_id=1`, { headers }).then(r => r.json()),
        fetch(`${API_URL}/locker/summary?tenant_id=1`, { headers }).then(r => r.json()),
        fetch(`${API_URL}/members/?tenant_id=1`, { headers }).then(r => r.json()),
      ]);
      setZones(Array.isArray(z) ? z : []);
      setLockers(Array.isArray(l) ? l : []);
      setSummary(s || {});
      setMembers(Array.isArray(m) ? m : []);
    } catch (e) { console.error(e); }
  }

  async function handleAssign() {
    if (!selectedMember || !assignForm.zone_id || !assignForm.locker_number || !assignForm.end_date) {
      alert('필수 항목을 입력해주세요.'); return;
    }
    const locker = lockers.find(l => l.zone_id === Number(assignForm.zone_id) && l.number === Number(assignForm.locker_number));
    if (!locker) { alert('락커를 찾을 수 없습니다.'); return; }
    try {
      const res = await fetch(`${API_URL}/locker/assign`, {
        method: 'POST', headers,
        body: JSON.stringify({
          tenant_id: 1, locker_id: locker.id, member_id: selectedMember.id,
          start_date: assignForm.start_date, end_date: assignForm.end_date,
          password: assignForm.password, memo: assignForm.memo,
        })
      });
      if (!res.ok) { const e = await res.json(); alert(e.detail || '배정 실패'); return; }
      alert('배정 완료됐습니다!');
      setShowAssignModal(false);
      setSelectedMember(null); setMemberSearch('');
      setAssignForm({ zone_id: '', locker_number: '', password: '', memo: '', start_date: new Date().toISOString().slice(0, 10), end_date: '' });
      loadAll();
    } catch (e) { alert('오류: ' + e.message); }
  }

  async function handleCreateZone() {
    if (!zoneForm.name) { alert('구역명을 입력해주세요.'); return; }
    try {
      await fetch(`${API_URL}/locker/zones`, { method: 'POST', headers, body: JSON.stringify({ ...zoneForm, tenant_id: 1 }) });
      alert('구역이 생성됐습니다!');
      setShowZoneModal(false);
      setZoneForm({ name: '', rows: 10, cols: 10, start_num: 1, end_num: 100, start_position: '왼쪽상단', direction: '좌우' });
      loadAll();
    } catch (e) { alert('오류: ' + e.message); }
  }

  async function handleUpdateZone() {
    if (!editZoneTarget) { alert('수정할 구역을 선택해주세요.'); return; }
    try {
      await fetch(`${API_URL}/locker/zones/${editZoneTarget}`, { method: 'PUT', headers, body: JSON.stringify({ ...editZoneForm, tenant_id: 1 }) });
      alert('수정 완료됐습니다!');
      setShowZoneModal(false);
      loadAll();
    } catch (e) { alert('오류: ' + e.message); }
  }

  async function handleCancelAssignment(assignmentId) {
    if (!window.confirm('배정을 취소하시겠습니까?')) return;
    await fetch(`${API_URL}/locker/assign/${assignmentId}`, { method: 'DELETE', headers });
    loadAll();
  }

  async function handleToggleDisabled(locker) {
    const newStatus = locker.status === 'disabled' ? 'available' : 'disabled';
    await fetch(`${API_URL}/locker/status/${locker.id}`, { method: 'PUT', headers, body: JSON.stringify({ status: newStatus }) });
    setSelectedLocker(null);
    loadAll();
  }

  const filteredMembers = members.filter(m => m.name?.includes(memberSearch) || m.phone?.includes(memberSearch));

  function renderLockerGrid(zone) {
    const zoneLockers = lockers.filter(l => l.zone_id === zone.id);
    const nums = Array.from({ length: zone.end_num - zone.start_num + 1 }, (_, i) => zone.start_num + i);
    return (
      <div style={{ overflowX: 'auto', paddingBottom: 6 }}>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${zone.cols}, minmax(54px, 1fr))`, gap: 6, minWidth: 'min-content' }}>
        {nums.map(num => {
          const locker = zoneLockers.find(l => l.number === num);
          const status = locker?.computed_status || 'available';
          const meta = STATUS_META[status];
          const isUsed = ['in_use', 'expiring', 'expired'].includes(status);
          const isFiltered = filterStatus !== 'all' && status !== filterStatus;
          return (
            <div key={num} onClick={() => locker && setSelectedLocker(locker)}
              style={{
                background: isFiltered ? '#f9fafb' : meta.bg,
                border: `1.5px solid ${isFiltered ? '#e5e7eb' : meta.color + '44'}`,
                borderRadius: 10, padding: '8px 4px', cursor: 'pointer',
                minHeight: 80, display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'space-between',
                opacity: isFiltered ? 0.4 : 1, transition: 'all 0.15s',
              }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#374151', alignSelf: 'flex-start', padding: '0 4px' }}>
                {String(num).padStart(3, '0')}
              </div>
              {isUsed ? (
                <>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#111', textAlign: 'center' }}>{locker.member_name}</div>
                  {status === 'expiring' && <div style={{ fontSize: 10, color: '#D97706' }}>만료 7일전</div>}
                  {status === 'expired' && <div style={{ fontSize: 10, color: '#EF4444' }}>기간 만료</div>}
                  <div style={{ width: '100%', background: meta.color, borderRadius: '0 0 8px 8px', padding: '3px 0', textAlign: 'center', fontSize: 9, color: '#fff', fontWeight: 600, marginTop: 2 }}>
                    {locker.start_date?.slice(2).replace(/-/g, '.')} - {locker.end_date?.slice(2).replace(/-/g, '.')}
                  </div>
                </>
              ) : status === 'disabled' ? (
                <div style={{ fontSize: 11, color: '#8B5CF6', fontWeight: 600 }}>사용불가</div>
              ) : (
                <div style={{ fontSize: 20, color: '#D1D5DB' }}>+</div>
              )}
            </div>
          );
        })}
      </div>
      </div>
    );
  }

  function renderPreview(rows, cols, startNum, endNum, startPosition, direction) {
    const total = Math.min(endNum - startNum + 1, rows * cols);
    
    // 그리드 배열 생성 (rows x cols)
    const grid = Array.from({ length: rows }, () => Array(cols).fill(null));
    
    // 시작 위치에 따라 행/열 순서 결정
    const rowOrder = startPosition?.includes('하단') 
      ? Array.from({ length: rows }, (_, i) => rows - 1 - i)
      : Array.from({ length: rows }, (_, i) => i);
    const colOrder = startPosition?.includes('오른쪽')
      ? Array.from({ length: cols }, (_, i) => cols - 1 - i)
      : Array.from({ length: cols }, (_, i) => i);

    // 번호 배치
    let num = startNum;
    if (direction === '상하') {
      // 열 우선 (세로 방향)
      for (let ci = 0; ci < cols && num <= endNum; ci++) {
        for (let ri = 0; ri < rows && num <= endNum; ri++) {
          grid[rowOrder[ri]][colOrder[ci]] = num++;
        }
      }
    } else {
      // 행 우선 (가로 방향)
      for (let ri = 0; ri < rows && num <= endNum; ri++) {
        for (let ci = 0; ci < cols && num <= endNum; ci++) {
          grid[rowOrder[ri]][colOrder[ci]] = num++;
        }
      }
    }

    return (
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 3 }}>
        {grid.flat().map((n, i) => (
          <div key={i} style={{ background: n ? '#3B82F6' : '#e5e7eb', borderRadius: 6, padding: '4px 2px', textAlign: 'center', fontSize: 11, color: n ? '#fff' : 'transparent', fontWeight: 600 }}>{n || '-'}</div>
        ))}
      </div>
    );
  }

  const activeForm = zoneTab === 'create' ? zoneForm : editZoneForm;

  return (
    <div style={{ position: 'relative' }}>
      {/* 헤더 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
        <span style={{ color: '#9ca3af', fontSize: 18 }}>‹</span>
        <h2 style={{ color: '#111', margin: 0, fontSize: 20, fontWeight: 700 }}>락커관리</h2>
      </div>

      {/* 상단 요약 카드 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, marginBottom: 20 }}>
        {['available', 'in_use', 'expiring', 'expired', 'disabled'].map(key => {
          const meta = STATUS_META[key];
          return (
            <div key={key} onClick={() => setFilterStatus(filterStatus === key ? 'all' : key)}
              style={{ background: meta.bg, borderRadius: 14, padding: '18px 20px', border: `1.5px solid ${filterStatus === key ? meta.color : meta.color + '22'}`, cursor: 'pointer' }}>
              <div style={{ fontSize: 13, color: meta.color, marginBottom: 6 }}>{meta.label}</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: meta.color }}>{summary[key] || 0}개</div>
            </div>
          );
        })}
      </div>

      {/* 회원 락커 검색 */}
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #f3f4f6', padding: 16, marginBottom: 16 }}>
        <input value={lockerQuery} onChange={e => setLockerQuery(e.target.value)}
          placeholder="회원명 또는 전화번호로 락커 찾기"
          style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
        {(() => {
          const q = lockerQuery.trim();
          const showResults = q || filterStatus !== 'all';
          if (!showResults) return null;
          let found;
          if (q) {
            const qd = q.replace(/-/g, '');
            found = lockers.filter(l => l.member_name && (String(l.member_name).includes(q) || String(l.member_phone || '').replace(/-/g, '').includes(qd)));
          } else {
            found = lockers.filter(l => l.computed_status === filterStatus);
          }
          return (
            <div style={{ marginTop: 12 }}>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>{q ? ('검색 결과 ' + found.length + '건') : ((STATUS_META[filterStatus]?.label) + ' ' + found.length + '개')}</div>
              {found.length === 0 ? (
                <div style={{ fontSize: 13, color: '#9ca3af', padding: '8px 4px' }}>결과가 없습니다.</div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                      {['번호', '이름', '전화번호', '기간', '상태'].map(h => (
                        <th key={h} style={{ padding: '8px 6px', textAlign: 'left', color: '#9ca3af', fontWeight: 600 }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {found.map(l => {
                      const meta = STATUS_META[l.computed_status] || {};
                      return (
                        <tr key={l.id} style={{ borderBottom: '1px solid #f9fafb', cursor: 'pointer' }}
                          onClick={() => setSelectedLocker(l)}
                          onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                          <td style={{ padding: '10px 6px', fontWeight: 700, color: '#374151' }}>{String(l.number).padStart(3, '0')}</td>
                          <td style={{ padding: '10px 6px', fontWeight: 600 }}>{l.member_name || '-'}</td>
                          <td style={{ padding: '10px 6px', color: '#6b7280' }}>{l.member_phone || '-'}</td>
                          <td style={{ padding: '10px 6px', color: '#6b7280', fontSize: 12 }}>{l.start_date ? l.start_date.slice(2).replace(/-/g, '.') : ''}{l.end_date ? '~' + l.end_date.slice(2).replace(/-/g, '.') : ''}</td>
                          <td style={{ padding: '10px 6px' }}><span style={{ fontSize: 11, fontWeight: 700, color: meta.color, background: meta.bg, padding: '2px 8px', borderRadius: 6 }}>{meta.label || l.computed_status}</span></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          );
        })()}
      </div>

      {/* 메인 레이아웃 - 핵심: table-layout으로 sticky 보장 */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>

        {/* 좌측 - 통합 박스 */}
        <div style={{ flex: 1, minWidth: 0, background: '#fff', borderRadius: 14, padding: 20, border: '1px solid #f3f4f6' }}>
          {/* 툴바 (드롭다운 + 락커관리 + 회원 락커 배정) */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18, flexWrap: 'wrap', gap: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <select value={selectedZone || (zones[0]?.id || '')} onChange={e => setSelectedZone(e.target.value ? Number(e.target.value) : null)}
                style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 13, color: '#374151', minWidth: 180 }}>
                {zones.map(z => <option key={z.id} value={z.id}>{z.name}</option>)}
              </select>
              <button onClick={() => setShowZoneModal(true)}
                style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', fontSize: 13, cursor: 'pointer' }}>
                ⚙ 락커 관리
              </button>
            </div>
            <button onClick={() => setShowAssignModal(true)}
              style={{ padding: '8px 16px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              + 회원 락커 배정
            </button>
          </div>

          {/* 락커 그리드 */}
          {zones.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af', background: '#fff', borderRadius: 14, border: '1px solid #f3f4f6' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>락커 구역이 없습니다</div>
              <div style={{ fontSize: 13 }}>락커 관리 버튼을 눌러 구역을 생성해주세요</div>
            </div>
          ) : (
            (selectedZone ? zones.filter(z => z.id === selectedZone) : (zones[0] ? [zones[0]] : [])).map(zone => (
              <div key={zone.id} style={{ marginBottom: 20 }}>
                {renderLockerGrid(zone)}
              </div>
            ))
          )}
        </div>

      </div>

      {/* 락커 상세 모달 */}
      {selectedLocker && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 360 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>{selectedLocker.zone_name} {String(selectedLocker.number).padStart(3, '0')}</div>
            {selectedLocker.member_name ? (
              <>
                <div style={{ background: '#f8fafc', borderRadius: 10, padding: 14, marginBottom: 14 }}>
                  <div style={{ fontSize: 13, marginBottom: 6 }}><b>회원:</b> {selectedLocker.member_name}</div>
                  <div style={{ fontSize: 13, marginBottom: 6 }}><b>연락처:</b> {selectedLocker.member_phone}</div>
                  <div style={{ fontSize: 13, marginBottom: 6 }}><b>기간:</b> {selectedLocker.start_date} ~ {selectedLocker.end_date}</div>
                  {selectedLocker.password && <div style={{ fontSize: 13 }}><b>비밀번호:</b> {selectedLocker.password}</div>}
                </div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                  <button onClick={() => {
                    setEditForm({
                      end_date: selectedLocker.end_date || '',
                      password: selectedLocker.password || '',
                      memo: selectedLocker.memo || '',
                      zone_id: String(selectedLocker.zone_id || ''),
                      locker_number: String(selectedLocker.number || ''),
                    });
                    setShowEditModal(true);
                  }} style={{ flex: 1, padding: 10, border: '1px solid #bfdbfe', borderRadius: 8, background: '#eff6ff', color: '#2563eb', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                    ✏️ 수정
                  </button>
                  <button onClick={() => handleCancelAssignment(selectedLocker.assignment_id)}
                    style={{ flex: 1, padding: 10, border: '1px solid #fecaca', borderRadius: 8, background: '#fff0f0', color: '#ef4444', cursor: 'pointer', fontSize: 13 }}>
                    배정 취소
                  </button>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => handleToggleDisabled(selectedLocker)}
                    style={{ flex: 1, padding: 10, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', color: '#374151', cursor: 'pointer', fontSize: 13 }}>
                    {selectedLocker.status === 'disabled' ? '사용가능으로' : '사용불가'}
                  </button>
                </div>
              </>
            ) : selectedLocker.status === 'disabled' ? (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ fontSize: 13, marginBottom: 12, color: '#8B5CF6', fontWeight: 600 }}>사용불가 상태입니다</div>
                <button onClick={() => handleToggleDisabled(selectedLocker)}
                  style={{ padding: '8px 20px', background: '#8B5CF6', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                  사용가능으로 변경
                </button>
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: '#9ca3af', padding: '20px 0' }}>
                <div style={{ fontSize: 13, marginBottom: 12 }}>비어있는 락커입니다</div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                  <button onClick={() => {
                    setAssignForm(f => ({ ...f, zone_id: String(selectedLocker.zone_id), locker_number: String(selectedLocker.number) }));
                    setSelectedLocker(null); setShowAssignModal(true);
                  }} style={{ padding: '8px 20px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                    배정하기
                  </button>
                  <button onClick={() => handleToggleDisabled(selectedLocker)}
                    style={{ padding: '8px 20px', background: '#fff', color: '#8B5CF6', border: '1px solid #C4B5FD', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                    사용불가
                  </button>
                </div>
              </div>
            )}
            <button onClick={() => setSelectedLocker(null)}
              style={{ width: '100%', marginTop: 12, padding: 10, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 13 }}>
              닫기
            </button>
          </div>
        </div>
      )}

      {/* 락커 수정 모달 */}
      {showEditModal && selectedLocker && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 400 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>락커 수정 — {selectedLocker.zone_name} {String(selectedLocker.number).padStart(3,'0')}</div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>구역 / 락커 번호 (자리 변경)</label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <select value={editForm.zone_id} onChange={e => setEditForm(f => ({ ...f, zone_id: e.target.value, locker_number: '' }))}
                  style={{ padding: '9px 10px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                  {zones.map(z => <option key={z.id} value={z.id}>{z.name}</option>)}
                </select>
                <select value={editForm.locker_number} onChange={e => setEditForm(f => ({ ...f, locker_number: e.target.value }))}
                  style={{ padding: '9px 10px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                  {lockers.filter(l => l.zone_id === Number(editForm.zone_id) && (!l.member_name || l.number === selectedLocker.number)).map(l => (
                    <option key={l.id} value={l.number}>{String(l.number).padStart(3,'0')}{l.number === selectedLocker.number ? ' (현재)' : ''}</option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>만료일 *</label>
              <input type="date" value={editForm.end_date} onChange={e => setEditForm(f => ({ ...f, end_date: e.target.value }))}
                style={{ width: '100%', padding: '9px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>비밀번호</label>
              <input value={editForm.password} onChange={e => setEditForm(f => ({ ...f, password: e.target.value }))}
                placeholder="락커 비밀번호"
                style={{ width: '100%', padding: '9px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>메모</label>
              <input value={editForm.memo} onChange={e => setEditForm(f => ({ ...f, memo: e.target.value }))}
                placeholder="메모"
                style={{ width: '100%', padding: '9px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setShowEditModal(false)}
                style={{ flex: 1, padding: 11, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', fontSize: 13, cursor: 'pointer' }}>
                취소
              </button>
              <button onClick={handleUpdate}
                style={{ flex: 2, padding: 11, border: 'none', borderRadius: 8, background: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                저장
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 회원 락커 배정 모달 */}
      {showAssignModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 480, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>회원 락커 배정</div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>회원 검색 *</label>
              <input value={memberSearch} onChange={e => { setMemberSearch(e.target.value); setSelectedMember(null); }}
                placeholder="이름 및 전화번호를 입력하세요"
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
              {memberSearch && !selectedMember && filteredMembers.length > 0 && (
                <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, maxHeight: 160, overflowY: 'auto', marginTop: 4 }}>
                  {filteredMembers.map(m => (
                    <div key={m.id} onClick={async () => {
  setSelectedMember(m);
  setMemberSearch(m.name);
  // 해당 회원의 락커 회원권만 조회 (category=locker)
  try {
    const memberships = await fetch(`${API_URL}/membership/by-member?member_id=${m.id}`, { headers }).then(r => r.json());
    const lockerMemberships = (Array.isArray(memberships) ? memberships : []).filter(ms =>
      ms.category === 'locker' && ms.status === 'ACTIVE'
    );
    setMemberLockerPlans(lockerMemberships);
  } catch (e) { setMemberLockerPlans([]); }
}}
                      style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f3f4f6' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                      onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                      {m.name} <span style={{ color: '#9ca3af', fontSize: 11 }}>{m.phone}</span>
                    </div>
                  ))}
                </div>
              )}
              {selectedMember && (
  <>
    <div style={{ marginTop: 6, padding: '8px 12px', background: '#eff6ff', borderRadius: 8, fontSize: 13, color: '#2563eb', fontWeight: 600 }}>
      ✓ {selectedMember.name} {selectedMember.phone}
    </div>
    {memberLockerPlans.length > 0 && (
      <div style={{ marginTop: 8 }}>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>보유 상품 선택</label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {memberLockerPlans.map(p => (
            <div key={p.id} onClick={() => {
              setAssignForm(f => ({ ...f, membership_id: p.id }));
            }}
              style={{
                padding: '8px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 12,
                border: `1.5px solid ${assignForm.membership_id === p.id ? '#2563EB' : '#e5e7eb'}`,
                background: assignForm.membership_id === p.id ? '#eff6ff' : '#f9fafb',
                color: assignForm.membership_id === p.id ? '#2563EB' : '#374151',
              }}>
              <span style={{ fontWeight: 600 }}>{p.plan_name || p.name || '락커 상품'}</span>
              <span style={{ marginLeft: 8, color: '#9ca3af' }}>{p.end_date ? `~${p.end_date}` : ''}</span>
              <span style={{ marginLeft: 8, color: '#9ca3af' }}>{p.days_remaining != null ? `${p.days_remaining}일 남음` : ''}</span>
            </div>
          ))}
        </div>
      </div>
    )}
    {selectedMember && memberLockerPlans.length === 0 && (
      <div style={{ marginTop: 6, padding: '8px 12px', background: '#fff7ed', borderRadius: 8, fontSize: 12, color: '#f97316' }}>
        ⚠ 해당 회원의 결제 내역이 없습니다
      </div>
    )}
  </>
)}
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>락커 구역 *</label>
              <select value={assignForm.zone_id} onChange={e => setAssignForm(f => ({ ...f, zone_id: e.target.value }))}
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                <option value="">구역 선택</option>
                {zones.map(z => <option key={z.id} value={z.id}>{z.name}</option>)}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>락커 번호 *</label>
                <input value={assignForm.locker_number} onChange={e => setAssignForm(f => ({ ...f, locker_number: e.target.value }))}
                  placeholder="번호 입력" type="number"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>비밀번호</label>
                <input value={assignForm.password} onChange={e => setAssignForm(f => ({ ...f, password: e.target.value }))}
                  placeholder="비밀번호 입력"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>시작일 *</label>
                <input type="date" value={assignForm.start_date} onChange={e => setAssignForm(f => ({ ...f, start_date: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>종료일 *</label>
                <input type="date" value={assignForm.end_date} onChange={e => setAssignForm(f => ({ ...f, end_date: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>메모</label>
              <textarea value={assignForm.memo} onChange={e => setAssignForm(f => ({ ...f, memo: e.target.value }))}
                placeholder="메모 입력" rows={3}
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', outline: 'none' }} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setShowAssignModal(false); setSelectedMember(null); setMemberSearch(''); }}
                style={{ flex: 1, padding: 12, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 14 }}>취소</button>
              <button onClick={handleAssign}
                style={{ flex: 1, padding: 12, border: 'none', borderRadius: 8, background: '#2563EB', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>등록</button>
            </div>
          </div>
        </div>
      )}

      {/* 락커 구역 생성/수정 모달 */}
      {showZoneModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 16, width: '85vw', maxWidth: 900, maxHeight: '90vh', overflowY: 'auto', display: 'flex' }}>
            {/* 좌측 */}
            <div style={{ width: 420, padding: 28, borderRight: '1px solid #f3f4f6', flexShrink: 0 }}>
              <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>락커 관리</div>
              {/* 탭 */}
              <div style={{ display: 'flex', marginBottom: 20, border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                <button onClick={() => setZoneTab('create')}
                  style={{ flex: 1, padding: '10px', border: 'none', background: zoneTab === 'create' ? '#2563EB' : '#fff', color: zoneTab === 'create' ? '#fff' : '#374151', fontWeight: zoneTab === 'create' ? 700 : 400, cursor: 'pointer', fontSize: 13 }}>
                  락커 신규 생성
                </button>
                <button onClick={() => setZoneTab('edit')}
                  style={{ flex: 1, padding: '10px', border: 'none', background: zoneTab === 'edit' ? '#2563EB' : '#fff', color: zoneTab === 'edit' ? '#fff' : '#374151', fontWeight: zoneTab === 'edit' ? 700 : 400, cursor: 'pointer', fontSize: 13 }}>
                  락커 수정
                </button>
              </div>

              {/* 수정탭 - 구역 선택 */}
              {zoneTab === 'edit' && (
                <div style={{ marginBottom: 14 }}>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>락커 구역 선택</label>
                  <select value={editZoneTarget || ''} onChange={e => {
                    const zid = Number(e.target.value);
                    setEditZoneTarget(zid);
                    const z = zones.find(z => z.id === zid);
                    if (z) setEditZoneForm({ name: z.name, rows: z.rows, cols: z.cols, start_num: z.start_num, end_num: z.end_num, start_position: z.start_position, direction: z.direction });
                  }} style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                    <option value="">구역 선택</option>
                    {zones.map(z => <option key={z.id} value={z.id}>{z.name}</option>)}
                  </select>
                </div>
              )}

              {/* 구역명 */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>락커 구역명 *</label>
                <input value={activeForm.name}
                  onChange={e => zoneTab === 'create' ? setZoneForm(f => ({ ...f, name: e.target.value })) : setEditZoneForm(f => ({ ...f, name: e.target.value }))}
                  placeholder="헬스장 입구 바깥쪽 락커 구역"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
              </div>

              <div style={{ fontSize: 13, fontWeight: 700, color: '#111', marginBottom: 12 }}>배치도</div>

              {/* 행x열 */}
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>행x열 설정 *</label>
                <div style={{ display: 'flex', gap: 12 }}>
                  {[['rows', '행(세로)'], ['cols', '열(가로)']].map(([key, label]) => (
                    <div key={key} style={{ flex: 1, display: 'flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                      <button onClick={() => zoneTab === 'create' ? setZoneForm(f => ({ ...f, [key]: Math.max(1, f[key] - 1) })) : setEditZoneForm(f => ({ ...f, [key]: Math.max(1, f[key] - 1) }))}
                        style={{ padding: '8px 12px', border: 'none', background: '#f9fafb', cursor: 'pointer' }}>−</button>
                      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <input type="number" value={activeForm[key]}
                          onChange={e => { const v = Math.max(1, parseInt(e.target.value || '1', 10) || 1); zoneTab === 'create' ? setZoneForm(f => ({ ...f, [key]: v })) : setEditZoneForm(f => ({ ...f, [key]: v })); }}
                          style={{ width: 44, textAlign: 'center', border: 'none', outline: 'none', fontSize: 13, background: 'transparent' }} />
                        <span style={{ fontSize: 12, color: '#9ca3af' }}>{label}</span>
                      </div>
                      <button onClick={() => zoneTab === 'create' ? setZoneForm(f => ({ ...f, [key]: f[key] + 1 })) : setEditZoneForm(f => ({ ...f, [key]: f[key] + 1 }))}
                        style={{ padding: '8px 12px', border: 'none', background: '#f9fafb', cursor: 'pointer' }}>+</button>
                    </div>
                  ))}
                </div>
              </div>

              {/* 시작-마지막 번호 */}
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>시작 - 마지막 번호 *</label>
                <div style={{ display: 'flex', gap: 12 }}>
                  {[['start_num', '시작'], ['end_num', '마지막']].map(([key]) => (
                    <div key={key} style={{ flex: 1, display: 'flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                      <button onClick={() => zoneTab === 'create' ? setZoneForm(f => ({ ...f, [key]: Math.max(1, f[key] - 1) })) : setEditZoneForm(f => ({ ...f, [key]: Math.max(1, f[key] - 1) }))}
                        style={{ padding: '8px 12px', border: 'none', background: '#f9fafb', cursor: 'pointer' }}>−</button>
                      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <input type="number" value={activeForm[key]}
                          onChange={e => { const v = Math.max(1, parseInt(e.target.value || '1', 10) || 1); zoneTab === 'create' ? setZoneForm(f => ({ ...f, [key]: v })) : setEditZoneForm(f => ({ ...f, [key]: v })); }}
                          style={{ width: 56, textAlign: 'center', border: 'none', outline: 'none', fontSize: 13, background: 'transparent' }} />
                        <span style={{ fontSize: 12, color: '#9ca3af' }}>번</span>
                      </div>
                      <button onClick={() => zoneTab === 'create' ? setZoneForm(f => ({ ...f, [key]: f[key] + 1 })) : setEditZoneForm(f => ({ ...f, [key]: f[key] + 1 }))}
                        style={{ padding: '8px 12px', border: 'none', background: '#f9fafb', cursor: 'pointer' }}>+</button>
                    </div>
                  ))}
                </div>
              </div>

              {/* 위치/방향 */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>시작 번호 위치 *</label>
                  <select value={activeForm.start_position}
                    onChange={e => zoneTab === 'create' ? setZoneForm(f => ({ ...f, start_position: e.target.value })) : setEditZoneForm(f => ({ ...f, start_position: e.target.value }))}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                    {['왼쪽상단', '오른쪽상단', '왼쪽하단', '오른쪽하단'].map(v => <option key={v}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5, display: 'block' }}>번호 배열 방향</label>
                  <select value={activeForm.direction}
                    onChange={e => zoneTab === 'create' ? setZoneForm(f => ({ ...f, direction: e.target.value })) : setEditZoneForm(f => ({ ...f, direction: e.target.value }))}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                    <option>좌우</option><option>상하</option>
                  </select>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => setShowZoneModal(false)}
                  style={{ flex: 1, padding: 12, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 14 }}>취소</button>
                <button onClick={zoneTab === 'create' ? handleCreateZone : handleUpdateZone}
                  style={{ flex: 1, padding: 12, border: 'none', borderRadius: 8, background: '#2563EB', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
                  {zoneTab === 'create' ? '등록' : '수정'}
                </button>
              </div>
            </div>

            {/* 우측 미리보기 */}
            <div style={{ flex: 1, padding: 28, overflowY: 'auto' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#374151', marginBottom: 16, textAlign: 'center' }}>미리보기</div>
              <div style={{ position: 'relative', padding: '20px 40px' }}>
                <div style={{ position: 'absolute', top: '50%', left: 8, transform: 'translateY(-50%)', fontSize: 12, color: '#9ca3af' }}>왼쪽</div>
                <div style={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', fontSize: 12, color: '#9ca3af' }}>오른쪽</div>
                <div style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af', marginBottom: 8 }}>상단</div>
                {renderPreview(activeForm.rows, activeForm.cols, activeForm.start_num, activeForm.end_num, activeForm.start_position, activeForm.direction)}
                <div style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af', marginTop: 8 }}>하단</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LockersPage;